export default {
  account: 'Account settings',
  billing: 'Billing',
  extension: 'Extension',
  notifications: 'Reminders and notifications',
  security: 'Security settings',
  teamMembers: 'Team members',
};
